import { makeAuthenticatedRequest } from '../utils/tokenUtils';

const submitFeedback = async (messageId, conversationId, easeOfUse, queryResp, ansAccuracy, suggestions) => {
    const url = process.env.REACT_APP_API_URL + 'feedback';

    // Construct the request payload
    const data = {
      message_id: messageId,
      ease_of_use: easeOfUse,
      query_resp: queryResp,
      conversation_id: conversationId,
      ans_accuracy: ansAccuracy,
      suggestions: suggestions,
    };

    try {
      const response = await makeAuthenticatedRequest(url, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json'
        }
      });

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error(
        'Error submitting feedback:',
        error.response ? error.response.data : error.message
      );
      throw error;
    }
};

export default submitFeedback;
  